const midpoint = 2

const properties = {
  strokeWidth: 1,
  strokeColour: 'black',
  lineLipWidth: 10,
  textPadding: 5,
}

type PropTypes = {
  label?: string,
  startPoint: number,
  endPoint: number,
  xOffset?: number,
}

const VerticalMeasurement = ({ label, startPoint, endPoint, xOffset = 0 }: PropTypes) => {
  return (
    <g>
      <text
        x={xOffset - (properties.lineLipWidth + properties.textPadding)}
        // Text should always display midway between the start and end points
        y={(startPoint + endPoint) / midpoint}
        textAnchor="middle"
        className="text-xs"
      >
        { label }
      </text>

      <line
        // The line should be offset by half the lip width so it's centred
        x1={xOffset - (properties.lineLipWidth / midpoint)}
        y1={startPoint}
        // The line should be offset by half the lip width so it's centred
        x2={xOffset + (properties.lineLipWidth / midpoint)}
        y2={startPoint}
        stroke={properties.strokeColour}
        strokeWidth={properties.strokeWidth}
      />
      <line
        x1={xOffset}
        y1={startPoint}
        x2={xOffset}
        y2={endPoint}
        stroke={properties.strokeColour}
        strokeWidth={properties.strokeWidth}
      />
      <line
        // The line should be offset by half the lip width so it's centred
        x1={xOffset - (properties.lineLipWidth / midpoint)}
        y1={endPoint}
        // The line should be offset by half the lip width so it's centred
        x2={xOffset + (properties.lineLipWidth / midpoint)}
        y2={endPoint}
        stroke={properties.strokeColour}
        strokeWidth={properties.strokeWidth}
      />
    </g>
  )
}

export default VerticalMeasurement
